'use strict'

export class EyeCatcherService {
  constructor($transitions) {
    'ngInject'
    Object.assign(
      this,
      {},
      {
        _scrollOffset: 0,
        _headerHeight: 0,
        _eyeCatcherHeight: 0,
        percent: 0,
      },
    )

    $transitions.onSuccess({ to: 'customers.**' }, () => {
      this.scrollOffset = 0
      this.percent = 0
    })
  }

  calculate() {
    const target = this._eyecatcherHeight - this._headerHeight
    this.percent = Math.min(100, parseInt((this._scrollOffset / target) * 100, 10))
  }

  set headerHeight(height) {
    this._headerHeight = height
    this.calculate()
  }

  set eyecatcherHeight(height) {
    this._eyecatcherHeight = height
    this.calculate()
  }

  set scrollOffset(offset) {
    this._scrollOffset = offset
    this.calculate()
  }
}



// WEBPACK FOOTER //
// ./app/shared/components/eye-catcher/eye-catcher.service.js